const GOOGLE_DRIVE_HOSTS = new Set([
  'drive.google.com',
  'www.drive.google.com',
  'docs.google.com',
  'www.docs.google.com',
]);

const GOOGLE_DRIVE_PREVIEW_HOST = 'drive.google.com';

const normalizeGoogleDriveUrl = (url: URL): string => {
  const pathMatch = /\/file\/d\/([^/]+)/i.exec(url.pathname);
  const idFromPath = pathMatch?.[1];
  const idFromQuery = url.searchParams.get('id');
  const fileId = idFromPath ?? idFromQuery;

  if (!fileId) {
    return url.toString();
  }

  return `https://${GOOGLE_DRIVE_PREVIEW_HOST}/uc?export=view&id=${fileId}`;
};

/**
 * Normalize external image URLs so they can be embedded in <img> tags.
 * Currently supports converting Google Drive share links into embeddable URLs.
 */
export function normalizeImageUrl(input: string): string {
  const trimmed = input.trim();
  if (!trimmed) {
    return trimmed;
  }

  let parsed: URL;
  try {
    parsed = new URL(trimmed);
  } catch {
    return trimmed;
  }

  const host = parsed.hostname.toLowerCase();

  if (GOOGLE_DRIVE_HOSTS.has(host)) {
    return normalizeGoogleDriveUrl(parsed);
  }

  const isGoogleDomain = host.endsWith('google.com');
  if (isGoogleDomain) {
    const pathname = parsed.pathname;
    if (pathname.startsWith('/imgres') || pathname.startsWith('/url')) {
      const imageParam = parsed.searchParams.get('imgurl') ?? parsed.searchParams.get('url');
      if (imageParam) {
        const decoded = imageParam.trim();
        if (decoded) {
          try {
            return new URL(decoded).toString();
          } catch {
            try {
              return new URL(decodeURIComponent(decoded)).toString();
            } catch {
              return decoded;
            }
          }
        }
      }
    }
  }

  return trimmed;
}

export function resolveDisplayImageUrl(value?: string | null): string | null {
  if (!value) {
    return null;
  }
  const normalized = normalizeImageUrl(value);
  return normalized.trim().length > 0 ? normalized : null;
}
